import styled from "styled-components";

export const DownloadContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 490px) {
    margin-bottom: 10px;
  }
`;
